import { render, staticRenderFns } from "./NewsCatalogPage.vue?vue&type=template&id=277743ab&scoped=true&"
import script from "./NewsCatalogPage.vue?vue&type=script&lang=js&"
export * from "./NewsCatalogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277743ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277743ab')) {
      api.createRecord('277743ab', component.options)
    } else {
      api.reload('277743ab', component.options)
    }
    module.hot.accept("./NewsCatalogPage.vue?vue&type=template&id=277743ab&scoped=true&", function () {
      api.rerender('277743ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewsCatalogPage.vue"
export default component.exports